const Card = ({ children, className }) => {
  const cName = className + ' card'
  return <div className={cName}>{children}</div>
}

export default Card
